import { PrivateCloud_CONSTANTS } from "./constants";
import CardsList from "@/components/cardsList";

const PrivateCloudCards = () => {
  const { title, desc, list } = PrivateCloud_CONSTANTS;
  return (
    <CardsList
      columns={{ base: 1, sm: 2, md: 4 }}
      desc={desc}
      list={list}
      spacing={{ base: 8, md: 12 }}
      title={title}
    />
  );
};

export default PrivateCloudCards;
